export const ALL = "ALL";

export const NEW = "NEW";
export const IN_PROGRESS = "IN_PROGRESS";
// export const ACCEPTED = "ACCEPTED";
export const SOLVED = "SOLVED"; // archived
export const WORK_DONE = "WORK_DONE";

export const processingStateTypes = [
  {
    id: NEW,
    name: "Neu",
    i18n: "ticket.processing_state.new",
  },
  // {
  //   id: ACCEPTED,
  //   name: "Freigegeben",
  //   i18n: "ticket.processing_state.accepted"
  // },
  {
    id: IN_PROGRESS,
    name: "In Bearbeitung",
    i18n: "ticket.processing_state.in_progress",
  },
  { id: WORK_DONE, name: "Erledigt", i18n: "ticket.processing_state.done" },
  // {
  //   id: SOLVED, name: "Archiviert", i18n: ""
  // },
  // { id: "NONE", name: "keine" }
];

// Generic async request lifecycle status
export const REQUEST_STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};
